import React from 'react';
import { Container, Typography, Button, Grid, Card, CardContent } from '@mui/material';

const Body = () => {
    return (
        <Container component="main" sx={{ flexGrow: 1, py: 8 }}>
            <section style={{ textAlign: 'center', padding: '4rem 0' }}>
                <Typography variant="h2" component="h2" gutterBottom sx={{ fontWeight: 'bold' }}>
                Bienvenue à NUEVO
                </Typography>
                <Typography variant="body1" color="text.secondary" paragraph>
                Découvrez l'innovation à son apogée. Explorez tout ce que NUEVO peut vous offrir.
                </Typography>
                <Button variant="contained" color="primary" size="large">
                Commencer
                </Button>
            </section>

            <section id="features" style={{ padding: '4rem 0' }}>
            <Grid container spacing={4}>
                {[
                    { title: "Recherche d'emploi intelligente", description: "Trouvez des offres adaptées à vos compétences et préférences grâce à notre algorithme avancé." },
                    { title: "Profil personnalisé", description: "Créez un profil professionnel attrayant pour attirer les recruteurs." },
                    { title: "Notifications en temps réel", description: "Recevez des alertes instantanées pour les nouvelles opportunités." }
                ].map((feature, index) => (
                    <Grid item xs={12} md={4} key={index}>
                        <Card sx={{ height: '100%', borderRadius: '16px', boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)' }}>
                            <CardContent>
                                <Typography variant="h5" component="h3" gutterBottom>
                                    {feature.title}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {feature.description}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </section>

        </Container>
    );
};

export default Body;